import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import { useCollapsibleContext } from './CollapsibleContext.js';
import btnReset from '../../utils/styles.js';
import ReactlyticsTracking from '../ReactlyticsTracking.js';

var CollapsibleHeading = function CollapsibleHeading(_ref) {
  var id = _ref.id,
      theme = _ref.theme,
      children = _ref.children,
      reactlytics = _ref.reactlytics,
      forId = _ref.forId,
      otherProps = _objectWithoutProperties(_ref, ["id", "theme", "children", "reactlytics", "forId"]);

  var _useCollapsibleContex = useCollapsibleContext(),
      handleCollapsibleHeadingClick = _useCollapsibleContex.handleCollapsibleHeadingClick,
      openAccordions = _useCollapsibleContex.openAccordions;
  /**
   * Calls the context event handler with original event and id
   *
   * @param {Object} event - The click event
   */


  var onButtonClick = function onButtonClick(event) {
    return handleCollapsibleHeadingClick(event, forId || id);
  };

  var isOpen = forId && !!openAccordions[forId] || !!openAccordions[id]; // Inline Hide Details buttons on focus outline dashed border to be not cut off from sides

  var forIdBtnstyle = {
    padding: '0px 3px 0 3px',
    '&:focus': {
      outlineOffset: '-1px'
    }
  }; // eslint-disable-next-line react-hooks/exhaustive-deps

  var styleObject = useMemo(function () {
    return merge.all([btnReset, forId && forIdBtnstyle, theme]);
  }, [theme]);
  return jsx(ReactlyticsTracking, {
    onClick: onButtonClick,
    reactlytics: reactlytics
  }, jsx("button", _extends({
    id: id,
    type: "button",
    "aria-expanded": isOpen,
    css: styleObject
  }, otherProps), children));
};

CollapsibleHeading.defaultProps = {
  children: null,
  theme: {},
  forId: ''
};

export default CollapsibleHeading;
